module.exports = __webpack_public_path__ + "src/img/artist/work08_2.jpg?a3d94816123d430d59ee100f131e372e";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work08_2.jpg
// module id = 161
// module chunks = 0